import React, { useState } from 'react';
import { translate } from 'react-i18next';
import Modal from 'react-modal';
import { trendingHashtagFetch, suggestedHashtagFetch } from '../../../actions/index';
import { Icon } from '../Icon';
import cx from '../../../styles';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

const Hashtags = (props) => {
    const [trendingHashtag, setTrendingHashtag] = useState([]);
    const [showSuggested, setShowSuggested] = useState(false);
    const { t } = props;
    if (props.showHashtag) {
        if (!trendingHashtag.length) {
            props.trendingHashtagFetch()
                .then((res) => {
                    if (res.hashtags) {
                        setTrendingHashtag([res.hashtags])
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
        }
    }
    const toggleSuggestedHash = () => {
        setShowSuggested(false)
    }
    return (
        props.showHashtag &&
        <div className={cx('hashtags')}>
            <div className={cx('wrap-hash')}>
                <p className={cx('add-hashtag')} onClick={() => { setShowSuggested(true) }}># {t('add_hashtag')}</p>
                {
                    trendingHashtag && trendingHashtag[0] && trendingHashtag[0].map((data, key) => {
                        return (
                            <p key={key} className={cx('trending-hashtag')} onClick={() => { props.onHashClick(data.label) }}>{data.label}</p>
                        )
                    })
                }
            </div>
            <SuggestedHashtags showSuggested={showSuggested}
                toggleSuggestedHash={toggleSuggestedHash}
                suggestedHashtagFetch={props.suggestedHashtagFetch}
                onHashClick={props.onHashClick}
                t={t}
            />
        </div>
    )
}

const SuggestedHashtags = (props) => {
    const [suggestedData, setSuggestedData] = useState([]);
    const [selectedHash, setSelectedHash] = useState('');
    const { t } = props;
    const onHashSelect = (hashtag) => {
        setSelectedHash(hashtag);
        const hashInput = document.querySelector('.hash-input');
        const text = hashtag.substring(1);
        hashInput.value = text;
    }
    const onHashSubmit = () => {
        const hashInput = document.querySelector('.hash-input');
        props.toggleSuggestedHash();
        setTimeout(() => {
            props.onHashClick(`#${hashInput.value}`);
        }, 100)
    }
    const afterOpenSuggestedHash = () => {
        document.querySelector('.hash-input').focus();
    }
    const onRequestClose = () => {
        props.toggleSuggestedHash();
        setSuggestedData([]);
        setTimeout(() => {
            document.getElementById('content').focus();
        }, 100)
    }
    const hashSearch = (e) => {
        props.suggestedHashtagFetch(e.target.value)
            .then((res) => {
                if (res.hashtags) {
                    setSuggestedData([res.hashtags])
                } else {
                    setSuggestedData([])
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }
    return (
        <Modal
            isOpen={props.showSuggested}
            onAfterOpen={afterOpenSuggestedHash}
            onRequestClose={onRequestClose}
            overlayClassName={"suggested-hashtag-modal"}
        >
            <span className={cx("close-modal")} onClick={onRequestClose}>
                <Icon name="cross-regular-dark-smd" />
            </span>
            <div className={cx('suggested-hash')}>
                <div className={cx('text')}>{t('suggested_hashtags')}</div>
                <div className={cx('input-wrap')}>
                    <span className={cx('hash')}>#</span>
                    <input className={cx('hash-input')} onChange={(e) => hashSearch(e)} placeholder={t('add_hashtag')}></input>
                </div>
                <div className={cx('suggested-wrap')}>
                    {
                        suggestedData && suggestedData[0] && suggestedData[0].map((data, key) => {
                            return (
                                <div className={cx('line-wrap')} key={key} onClick={() => { onHashSelect(data.label) }}>
                                    <p className={cx('hashtag')}>{data.label}</p>
                                    {
                                        data.label.toLocaleLowerCase() === selectedHash.toLocaleLowerCase() ?
                                            <Icon name="add-select-hashtag-regular" />
                                            :
                                            <Icon name="add-hashtag-regular" />
                                    }
                                </div>
                            )
                        })
                    }
                </div>
                <div className={cx('submit')}>
                    <button className={cx('submit-hash')} onClick={() => { onHashSubmit(); }}>{t('submit')}</button>
                </div>
            </div>
        </Modal>
    )
}

//map state
const mapStateToProps = (state) => state;

//map dispatch
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        trendingHashtagFetch,
        suggestedHashtagFetch
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(translate()(Hashtags));
